export const pl = {
  billing: {
    title: 'Płatności i Subskrypcja',
    description: 'Zarządzaj swoją subskrypcją i informacjami o płatnościach',
    currentPlan: 'Aktualny Plan',
    upgradePlan: 'Uaktualnij Swój Plan',
    choosePlan: 'Wybierz plan, który jest dla Ciebie najlepszy',
    features: 'Funkcje',
    billingInfo: 'Informacje o Płatnościach',
    currentPeriod: 'Obecny Okres',
    manageSubscription: 'Zarządzaj Subskrypcją',
    selectPlan: 'Wybierz {plan}',
    popular: 'Popularny',
    savePercent: 'Oszczędź {percent}%',
    perMonth: '/miesiąc',
    perYear: '/rok',
    billedAnnually: '(płatne rocznie)',
    monthly: 'Miesięcznie',
    annual: 'Rocznie',
    success: {
      title: 'Subskrypcja Aktywowana!',
      description: 'Twoja płatność przebiegła pomyślnie i subskrypcja jest teraz aktywna.',
      message: 'Masz teraz dostęp do wszystkich funkcji premium. Dziękujemy za zakup!',
      planActivated: 'został aktywowany',
      goToApp: 'Przejdź do Aplikacji',
      manageBilling: 'Zarządzaj Płatnościami',
      continue: 'Przejdź do Płatności',
    },
    cancel: {
      title: 'Płatność Anulowana',
      description: 'Twoja płatność została anulowana i nie zostały naliczone żadne opłaty.',
      message: 'Możesz spróbować ponownie w dowolnym momencie. Jeśli potrzebujesz pomocy, skontaktuj się z naszym zespołem wsparcia.',
      tryAgain: 'Spróbuj Ponownie',
      goToApp: 'Przejdź do Aplikacji',
    },
    status: {
      active: 'Aktywny',
      canceled: 'Anulowany',
      canceling: 'Anulowanie',
      pastDue: 'Zaległości',
      grandfathered: 'Dożywotni',
    },
    grandfathered: {
      title: 'Dożywotni Dostęp Pro',
      message: 'Masz dożywotni dostęp do funkcji Pro. Dziękujemy za bycie wczesnym wsparciem!',
    },
    planSuffix: 'Plan',
    currentPeriodLabel: 'Obecny Okres:',
    subscriptionWillCancel: 'Subskrypcja zostanie anulowana w dniu',
    plans: {
      free: {
        name: 'Darmowy',
        description: 'Zacznij z podstawowymi funkcjami',
        fullName: 'Plan Darmowy',
        features: {
          basicGearManagement: 'Podstawowe zarządzanie sprzętem',
          dataExport: 'Eksport danych (JSON/Markdown)',
          byok: 'BYOK: Użyj własnego klucza API (OpenRouter)',
          storage: '100 MB przestrzeni',
          itemsLimit: 'Limit 2 000 przedmiotów',
          containersLimit: 'Limit 100 kontenerów',
        },
      },
      pro: {
        name: 'Pro',
        description: 'Idealny do użytku osobistego',
        fullName: 'Plan Pro',
        features: {
          everythingInFree: 'Wszystko z planu Darmowy',
          aiRecommendations: 'Rekomendacje sprzętu wspierane przez AI',
          aiTokens: '~$1 w tokenach AI/miesiąc',
          advancedFeatures: 'Zaawansowane funkcje',
          storage: '5 GB przestrzeni',
          itemsLimit: 'Limit 10 000 przedmiotów',
          containersLimit: 'Limit 250 kontenerów',
        },
      },
      pro_plus: {
        name: 'Pro Plus',
        description: 'Maksymalne limity dla zaawansowanych użytkowników',
        fullName: 'Plan Pro Plus',
        features: {
          everythingInPro: 'Wszystko z planu Pro',
          priorityAi: 'Priorytetowe przetwarzanie AI',
          aiTokens: '~$10 w tokenach AI/miesiąc',
          premiumSupport: 'Premium wsparcie',
          storage: '50 GB przestrzeni',
          itemsLimit: 'Limit 50 000 przedmiotów',
          containersLimit: 'Limit 500 kontenerów',
        },
      },
    },
    upgradeBanner: {
      title: 'Odblokuj Funkcje Premium',
      description: 'Przejdź na plan Pro, aby uzyskać rekomendacje AI, zaawansowane funkcje i więcej przestrzeni.',
      button: 'Zobacz Plany',
      dismiss: 'Zamknij baner premium',
    },
    errors: {
      checkoutFailed: 'Nie udało się utworzyć sesji checkout. Spróbuj ponownie.',
      portalFailed: 'Nie udało się otworzyć portalu rozliczeniowego. Spróbuj ponownie.',
    },
  },
}
